import { CLUBHOUSE_PHOTOS, CLUBHOUSE_INTRO } from "@/data/photos";

const FIGURE = { large: "", small: "mx-auto max-w-sm", tall: "mx-auto max-w-md" };
const IMG = {
  large: "w-full max-h-[70vh] object-cover sm:max-h-[80vh]",
  small: "w-full",
  tall: "mx-auto max-h-[60vh] w-auto sm:max-h-[520px]",
};

export const ClubhouseSection = () => (
  <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6 sm:py-10">
    <p className="text-xs font-bold uppercase tracking-[0.3em] text-cypress-gold">The Clubhouse</p>
    <h2 className="mt-1 text-2xl font-bold tracking-tight sm:text-3xl">No stats. Just the boys.</h2>
    {CLUBHOUSE_INTRO?.trim() && (
      <p className="mt-3 max-w-2xl text-sm italic leading-relaxed text-cypress-cream/60" data-testid="clubhouse-intro">
        {CLUBHOUSE_INTRO}
      </p>
    )}
    <div className="mt-6 space-y-6" data-testid="clubhouse-list">
      {CLUBHOUSE_PHOTOS.map((photo, i) => (
        <figure key={photo.src} data-testid={`clubhouse-photo-${i + 1}`} className={FIGURE[photo.size] ?? ""}>
          <img
            src={photo.src}
            alt={photo.alt}
            loading="lazy"
            className={`rounded-xl border border-cypress-gold/20 ${IMG[photo.size] ?? IMG.large}`}
            style={photo.size === "large" ? { objectPosition: "50% 62%" } : undefined}
          />
          {photo.caption && <figcaption className="mt-2 text-center text-sm text-cypress-cream/60">{photo.caption}</figcaption>}
        </figure>
      ))}
    </div>
  </div>
);
